<template>
  <div class="lottery-and-task">
    <div class="lottery-and-task-title" :class="curLang"></div>
    <div class="lottery-and-task-sub-title">
      <i class="lottery-and-task-sub-title-icon"></i>
      <span v-html="langData.lotterySubTitle"></span>
      <i class="lottery-and-task-sub-title-icon"></i>
    </div>
    <div class="lottery-and-task-content">
      <Lottery />
      <Task />
    </div>
    <div class="top-reward-highlights">
      <div class="top-reward-subtitle" :class="curLang">{{ langData.drawSubTitle }}</div>
      <div class="top-reward-section">
        <div class="top-reward-label">{{ langData.physicalRewardsLabel }}</div>
        <div class="top-reward-list">
          <div class="top-reward-item physical" v-for="key in physicalAwards" :key="key">
            <div class="top-reward-icon-box">
              <div class="top-reward-icon" :class="`award-${key} ${curLang}`"></div>
            </div>
            <div class="top-reward-name">{{ langData[awardConfig[key]] }}</div>
          </div>
        </div>
      </div>
      <div class="top-reward-section">
        <div class="top-reward-label">{{ langData.inGameRewardsLabel }}</div>
        <div class="top-reward-list">
          <div class="top-reward-item in-game" v-for="key in inGameAwards" :key="key">
            <div class="top-reward-icon-box">
              <div class="top-reward-icon" :class="`award-${key} ${curLang}`"></div>
            </div>
            <div class="top-reward-name">{{ langData[awardConfig[key]] }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Lottery from "./Lottery.vue";
import Task from "./Task.vue";
import LanguageHook from "@/hooks/language";
import { awardConfig } from "@/config/index";

const { curLang, langData } = LanguageHook();

const physicalAwards = ["Doll", "Card", "Tshirt", "Backpack", "Photocard"];
const inGameAwards = ["Title", "Avatar", "Headwear", "Blindbox", "Zeny"];
</script>

<style scoped lang="less"></style>
